import { useEffect } from 'react';
import { useMediaPipeStore } from '@/zustand/media-pipe-store';

function scheduleIdleInitialization(callback) {
  if (typeof window === 'undefined') {
    callback();
    return () => {};
  }

  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(callback, { timeout: 2000 });
    return () => {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
    };
  }

  const timeoutId = window.setTimeout(callback, 250);
  return () => window.clearTimeout(timeoutId);
}

const MediaPipeBootstrap = () => {
  const initializePoseLandmark = useMediaPipeStore(state => state.initializePoseLandmark);

  useEffect(() => {
    const cancelIdleInitialization = scheduleIdleInitialization(() => {
      void initializePoseLandmark();
    });

    return () => {
      cancelIdleInitialization();
    };
  }, [initializePoseLandmark]);

  return null;
};

export default MediaPipeBootstrap;
